// Header displays the header image and the page's title
//    - @author Manuel Ondina <manuel-rafael.ondina-aja@hp.com>
//    - @date June 9th, 2023
//    - @copyright Copyright (c) HP Inc, 2023
//        All rights reserved. Copying or other reproduction of this program except
//        for archival purposes is prohibited without written consent of HP Inc.

import React, { useEffect } from 'react';
import Content from '../Content';
import { HomeContainer } from './styles';
import { GoogleTagManager } from '../../assets/static/googleTagManager';
import useShellRootContext from '../../contexts/ShellRoot/useShellRootContext';
import { Hotjar } from 'src/assets/static/hotjar';
import { getHotjarID } from 'src/utils/utils';

// Home displays the home page
const Home = () => {
  const { interfaces } = useShellRootContext();
  const stack = interfaces.v1.app.getPortalStack();

  // Append Analytics script to head/body when the component is rendered for the first time
  useEffect(() => {
    // GoogleTagManager
    GoogleTagManager.init(stack);
    // HotJar
    Hotjar.init(getHotjarID(stack));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Redirect to https://build.hp.com after 5 seconds
  useEffect(() => {
    const timer = setTimeout(() => {
      window.location.href = 'https://build.hp.com';
    }, 5000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <HomeContainer id="home-wrapper">
      <Content></Content>
    </HomeContainer>
  );
};

export default Home;
